jQuery(function(){

    jQuery('.text-field--calendar').each(function(){
        jQuery(this).pikaday({
            format: "MM/DD/YYYY"
        });

    });

    if(jQuery('.text-field--calendar').length>0){
        jQuery('.text-field--calendar').mask('00/00/0000');
    }

});
